import { AdminType } from "./enums/AdminType";
import { SaleChannel } from "./SaleChannel";

export enum ClientInputPermission {
    AUTHORIZED = 0,
    UNAUTHORIZED = 2,
    ONLY_IF_TODAY = 3,
}

export enum ClientFieldRule {
    DISABLED = 0,
    OPTIONAL = 1,
    REQUIRED = 2,
}

export type Admin = {
    admin_id: number;
    admin_gratuite_desactiver: boolean;
    admin_caisse_nom: ClientFieldRule;
    admin_caisse_prenom: ClientFieldRule;
    admin_caisse_mail: ClientFieldRule;
    admin_caisse_tel: ClientFieldRule;
    admin_caisse_specifique: boolean;
    admin_caisse_client: boolean;
    admin_caisse_client_guichet: ClientInputPermission;
    admin_type_id: AdminType | number;
    canal_vente?: SaleChannel;
};
